app.service('partnerSubscription', function (partnerSubscriptionGroup) {

	function init(props) {
		props.$el.find('.partner-subscription-group').each(function () {
			partnerSubscriptionGroup.instanceOf($(this));
		});
	}

	return {
		init
	};
});